module.exports = __webpack_public_path__ + "35394636a0fd19a4c14204c526dec9f9.svg";